<template>
  <div>
    <div class="bg_container" v-lazy:background-image="bg_img">
      <div class="tools" :style="{ height: isExpand ? '270px' : '50px' }">
        <van-image @click="isExpand = !isExpand" style="margin-bottom: 9px"
          class="click_able" width="20" height="11" fit="cover" :src="
            isExpand
              ? '/images/triangle_top.png'
              : '/images/triangle_bottom.png'
          " />
        <div class="circle click_able" v-show="isExpand"
          @click="setShowMore(!showMore)">
          <van-image width="24" height="24" fit="cover"
            src="/images/icon_more.png" />
          <div class="title">更多</div>
        </div>
        <div class="circle click_able" v-show="isExpand" @click="screenfull">
          <van-image width="24" height="24" fit="cover"
            src="/images/icon_fullscreen.png" />
          <div class="title">满屏</div>
        </div>
        <div class="circle click_able" v-show="isExpand" @click="navigateback">
          <van-image width="24" height="24" fit="cover"
            src="/images/icon_back.png" />
          <div class="title">返回</div>
        </div>
      </div>
      <div class="bg_wrapper">
        <router-view v-if="isRouterAlive"></router-view>
      </div>
    </div>
    <writing-canvas v-if="pptInfo.show && !hidePPT"
      @closeCanvas="handleEndScreen({ type: 'ppt' })" canvasid="canvas"
      :bgImage="pptInfo.files[pptInfo.nowPage]" :zindex="5" ref="canvas">
    </writing-canvas>
    <van-popup v-model="projection.show" round @close="closePopup" closeable
      v-if="projection.mode !== 'image' && projection.mode">
      <video :src="projection.fileurl" x5-playsinline id="videoModel"
        playsinline webkit-playsinline autoplay controls="controls"
        style="width: 100vw; height: 100vh"
        v-if="projection.mode === 'video'"></video>
      <audio controls="controls" autoplay webkit-playsinline playsinline
        x5-playsinline :src="$store.state.course.projection.fileurl"
        id="audioModel" style="width: 100vw; height: 100px"
        v-else-if="projection.mode === 'audio'"></audio>
      <iframe :src="projection.fileurl"
        v-else-if="projection.mode === 'office' || projection.mode === 'pdf'"
        class="preview-document"></iframe>
    </van-popup>
    <writing-canvas v-if="imagePreview.show" :bgImage="imagePreview.files[0]"
      :zindex="6" @closeCanvas="closePopup" canvasid="image" ref="image">
    </writing-canvas>
    <More v-if="showMore" @close="setShowMore(false)"
      @quit="sendFinishTeaching(true)"></More>
  </div>
</template>
<script>
// @ is an alias to /src
import Vue from 'vue';
import course from '@/api/course/index';
import '@vant/touch-emulator';
import {
  Image,
  Row,
  Col,
  List,
  Toast,
  Popup,
  ImagePreview,
  Swipe,
  SwipeItem,
  Dialog
} from 'vant';
import baseUrl from '@/api/baseUrl';
import screenfull from 'screenfull';
import user from '@/api/user/index';
import More from '@/components/home/more';
import utils from '@/utils/index';
import WritingCanvas from '@/components/WritingCanvas';
Vue.use(Image)
  .use(Row)
  .use(Col)
  .use(List)
  .use(Toast)
  .use(Popup)
  .use(ImagePreview)
  .use(Swipe)
  .use(SwipeItem);
export default {
  name: 'homeIndex',
  components: {
    WritingCanvas,
    More
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  computed: {
    pptInfo() {
      return this.$store.state.course.pptInfo;
    },
    imagePreview() {
      return this.$store.state.course.imagePreview;
    },
    projection() {
      return this.$store.state.course.projection;
    }
  },
  data() {
    return {
      isRouterAlive: false,
      bg_img: '/images/background@2x.png',
      isLoading: false,
      isExpand: false,
      showMore: false,
      transform_scale: 0.5,
      transform_rotate: 0,
      transform_pdf_scale: 1,
      isStopScroll: false,
      showFile: true,
      hidePPT: false,
      showCanvas: false,
      isFinishing: false
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    // 视频、图片、音频关闭
    closePopup() {
      console.log('closePupup');
      this.$store.commit('course/setProjection', {
        fileurl: '',
        filename: '',
        mode: '',
        show: false
      });
      this.handleEndScreen({ type: 'image' });
    },
    // 设置查看更多
    setShowMore(flag = false) {
      console.log('flag', flag);
      this.showMore = flag;
    },
    navigateback() {
      if (this.$route.name === 'homeMain') return false;
      console.log('goback');
      this.$router.go(-1);
    },
    onLoad() {
      console.log('asd');
      this.isLoading = false;
    },
    // 结束授课
    async handleFinished(sendMessage = false) {
      try {
        if (sendMessage) {
          let status = await this.handleSendMessage('finished');
          if (status < 0) return false;
        }
        console.log('finished course');
        this.$store.commit('CLEAR_STORAGE');
        this.$router.replace(`/`);
      } catch (error) {
        console.log('error', error);
      }
    },
    // ppt
    async handlePPT(data) {
      let { nowPage, galleryid, isClear, width, height } = data;
      let { pptInfo } = this.$store.state.course;
      this.showCanvas = true;
      this.$store.commit('course/setValue', {
        name: 'canvasInfo',
        value: { width, height }
      });
      if (pptInfo.galleryid === galleryid && pptInfo.files.length) {
        console.log(nowPage);
        if (isClear) this.$refs.canvas.drawGraphical(data);
        this.$store.commit('course/setPPTPage', { nowPage });
      } else {
        let { items } = await course.getGalleryFiles({
          params: {
            galleryid: galleryid
          },
          loadingText: '正在加载ppt文件',
          errorFn: this.handleError
        });
        if (items) {
          let files = items
            .filter((file) => file.source === 'png')
            .map((v) => {
              let file = utils.formatUrlWstoken(v.file);
              return file;
            });
          this.$store.commit('course/setPPTFiles', {
            data: files,
            galleryid,
            nowPage,
            width,
            height
          });
        }
      }
    },
    // ppt切换页面
    onChange(index) {
      this.handlePPT({ nowPage: index, galleryid: this.pptInfo.galleryid });
    },
    // pdf
    handleScrollPdf(type = 0) {
      const _this = this;
      var $dom = _this.$el.querySelector('.files');
      var winHeight = $dom.offsetHeight - 160;
      if (type === 0) {
        winHeight = -winHeight;
      }
      $dom.scrollBy(0, winHeight);
      var scrollTop = $dom.scrollTop;
      var scrollHeight = $dom.clientHeight;
      var domHeight = $dom.scrollHeight;
      if (scrollTop + scrollHeight >= domHeight) {
        if (this.isStopScroll) Toast(`已经到达底部啦`);
        this.isStopScroll = true;
        // console.log("到达底部啦");
      } else if (scrollTop === 0 && winHeight < 0) {
        if (this.isStopScroll) {
          Toast(`已经到达顶部啦`);
          // console.log("到达顶部啦");
        }
        this.isStopScroll = true;
      } else {
        this.isStopScroll = false;
      }
    },
    // pdf缩放
    handleZoomPdf(value) {
      var $dom = this.$el.querySelector('.files img');
      this.transform_pdf_scale = this.transform_pdf_scale + value / 10;
      if (this.transform_pdf_scale > 1.08) {
        this.transform_pdf_scale = 1.1;
      } else if (this.transform_pdf_scale < 0.7) {
        this.transform_pdf_scale = 0.7;
      }
      // console.log("value", this.transform_pdf_scale);
      $dom.style.transform = `scale(${this.transform_pdf_scale})`;
      Toast(`${parseInt(this.transform_pdf_scale * 100)}%`);
    },
    // 测验
    handleQuiz({ quizid, codeid, curPage }, isStart) {
      // console.log("quizid", quizid);
      this.$store.commit('course/setValue', {
        name: 'quizId',
        value: quizid
      });
      this.$store.commit('course/setValue', {
        name: 'qcodeid',
        value: codeid
      });
      this.$store.commit('course/setValue', {
        name: 'curPage',
        value: curPage
      });
      this.handleEndScreen({ type: 'ppt' });
      if (isStart) {
        this.$router.push({
          path: '/quizcountdown',
          query: { qid: quizid, cid: codeid }
        });
      } else {
        this.$router.push({
          path: '/quizsituation',
          query: { qid: quizid, cid: codeid, page: curPage }
        });
      }
    },
    // 随堂提问
    handleFllowQuestion({ forumid, disid }) {
      console.log('forumid', forumid);
      this.$store.commit('course/setValue', {
        name: 'forumid',
        value: forumid
      });
      this.$store.commit('course/setValue', {
        name: 'disid',
        value: disid
      });
      this.$store.commit('course/clearRaiseStudents');
      this.handleEndScreen({ type: 'ppt' });
    },
    // 随堂提问-学生举手
    handleRaiseHand({ userid, avatar, username }) {
      console.log('userid', userid);
      console.log('userid', this.$store.state.course);
      this.$store.commit('course/setUpdateStudents', {
        userid,
        avatar,
        username
      });
    },
    // 讨论区
    handleForum({ forumid }) {
      // console.log("forumid", forumid);
      this.$store.commit('course/setValue', {
        name: 'forumid',
        value: forumid
      });
      this.handleEndScreen({ type: 'ppt' });
      this.$router.push({ path: '/forum', query: { fid: forumid } });
    },
    // 投票
    handleVote({ choiceid }) {
      // console.log("choiceid", choiceid);
      this.$store.commit('course/setValue', {
        name: 'choiceid',
        value: choiceid
      });
      this.handleEndScreen({ type: 'ppt' });
      this.$router.push('/vote');
    },
    // 白板
    handleWhiteboard({ width, height }) {
      console.log('canvasWidth', width);
      this.$store.commit('course/setValue', {
        name: 'mobileInfo',
        value: { width, height }
      });
      this.handleEndScreen({ type: 'ppt' });
      this.$router.push('/whiteboard');
    },
    // 白板-绘画
    handleDrawing(data) {
      switch (data.type) {
        case 'whiteboard':
          // console.log("白板");
          this.$root.$emit('boardDrawing', data);
          break;
        case 'draw':
          // console.log(data.type);
          this.handleWriting(data);
          break;
      }
    },
    // dialog弹窗
    handleShowDialog({ type, tips }) {
      this.$dialog.confirm({ message: tips }).then(() => {});
    },
    // 关闭dialog弹窗
    handleCloseDialog() {
      this.$dialog.close();
    },
    // ppt/图片画板
    handleWriting(data) {
      console.log('writing data', data);
      const { type, width, height, isImage } = data;
      let domType = 'canvas';
      console.log('handlewriting', width, height);
      if (isImage) domType = 'image';
      switch (type) {
        case 'draw':
          this.$refs[domType].dodraw({ data });
          break;
        case 'redo':
          this.$refs[domType].redo();
          break;
        case 'clear':
          this.$refs[domType].drawGraphical(data);
          break;
      }
    },
    // 结束投屏
    handleEndScreen({ type }) {
      // console.log("type:", type);
      switch (type) {
        case 'ppt':
          this.$store.commit('course/endPPTScreen');
          break;
        case 'image':
          this.$store.commit('course/setPreviewFiles', {
            fileurl: '',
            show: false
          });
          break;
        case 'video':
          if (document.getElementById('videoModel')) {
            document.getElementById('videoModel').pause();
          }
          this.closePopup();
          break;
        case 'audio':
          if (document.getElementById('audioModel')) {
            document.getElementById('audioModel').pause();
          }
          this.closePopup();
          break;
        case 'quiz':
        case 'pdf':
        case 'randomCall':
        case 'randomQuestion':
        case 'forum':
        case 'whiteboard':
        case 'vote':
        case 'attend':
          this.transform_pdf_scale = 1;
          this.navigateback();
          break;
        case 'quizDetail':
          this.handleCloseDialog();
          this.$router.push('/home');
      }
    },
    // 预览文件
    previewFile(filename, fileurl, file, isFairy = false) {
      this.$store.dispatch('course/PriviewFile', {
        filename,
        fileurl,
        file,
        isFairy
      });
    },
    handleStudentOnline({ name, userid }) {
      console.log('userid', userid);
      this.$store.commit('course/setUpdateOnlineStudents', {
        username: name,
        userid
      });
    },
    clickPPT() {
      this.hidePPT = true;
    },
    async sendFinishTeaching(sendMsg = true) {
      this.isFinishing = true;
      if (sendMsg) {
        let status = await this.handleSendMessage('finished', {}, 'all');
        if (status < 1) return;
      }
      let result = await course.sendFinishTeaching({
        params: { codeid: this.$store.state.course.code },
        loadingText: '正在结束课程....',
        errorFn: this.handleError
      });
      this.isFinishing = false;
      if (result) {
        console.log('end course result', result);
        this.handleFinished();
      } else {
        Dialog.confirm({
          title: '提示',
          message: '结束授课失败',
          confirmButtonText: '强制退出'
        })
          .then(() => {
            this.handleFinished();
          })
          .catch(() => {});
      }
    },
    async handleSendMessage(cmd, data, to = 'wechat') {
      // console.log("code", this.$store.state.course.code);
      let params = {
        codeid: this.$store.state.course.code,
        to,
        type: cmd, //
        // clientid: data.clientid,
        data: JSON.stringify({ ...data })
      };
      let { status } = await course.sendMessage({
        params: params,
        loadingText: '',
        errorFn: this.handleError
      });
      if (status === -1 && to !== 'student') {
        console.warn('wechat has logout');
        this.$store.commit('course/setTeacherOnline', false);
        this.$store.commit('global/setLoading', {
          flag: true,
          title: '等待连接中...'
        });
        // 小程序端已经下线
        // Dialog.confirm({
        //   title: "下线通知",
        //   message: "检测到小程序端处于离线状态,请点击确定重新连接",
        // }).then(() => {
        //   this.sendFinishTeaching(false);
        // });
      } else {
        this.$store.commit('course/setTeacherOnline', true);
        this.$store.commit('global/setLoading', { flag: false, title: '' });
      }
      return status;
    },
    // 监听socket message
    setOnMessage() {
      const _this = this;
      try {
        this.$store.getters['websock/STAFF_UPDATE'].onmessage = async function (
          evt
        ) {
          // console.log("evt", evt);
          let message = JSON.parse(evt.data);
          console.log('course receive a message', message);
          const { data, type } = message;
          if (
            type !== 'ping' &&
            type !== 'helloall' &&
            _this.$store.state.global.loadingShow
          ) {
            _this.$store.commit('global/setLoading', {
              flag: false,
              title: ''
            });
          }
          switch (type) {
            case 'ping':
              _this.$store.getters['websock/STAFF_UPDATE'].send(
                JSON.stringify({ type: 'pong' })
              );
              break;
            case 'hello':
              console.log('page index', data.clientid);
              await user.switchClienId({
                params: {
                  type: 'web',
                  old: _this.$store.state.websock.clienId,
                  new: data.clientid
                },
                loadingText: '正在切换clientId',
                errorFn: this.handleError
              });
              await _this.handleSendMessage('changeWebclientId', {
                clientid: data.clientid
              });
              _this.$store.commit('websock/STAFF_UPDATECLIENID', data.clientid);
              break;
            // 教师上线
            case 'onLine':
              _this.$store.commit('course/setTeacherOnline', true);
              break;
            // 结束授课
            case 'finished':
              if (!_this.isFinishing) {
                _this.handleFinished();
              }
              break;
            case 'ppt':
              _this.hidePPT = false;
              _this.handlePPT(JSON.parse(data[0]));
              break;
            case 'image':
              _this.transform_scale = 1;
              _this.transform_rotate = 0;
              let { file, width, height } = JSON.parse(data[0]);
              _this.$store.commit('course/setValue', {
                name: 'canvasInfo',
                value: { width, height }
              });
              if (data[0].indexOf('?')) {
                let fUrl = file.split('?');
                _this.previewFile(file, `${fUrl[0]}`, fUrl[0], true);
              } else {
                _this.previewFile(file, file, file, true);
              }
              break;
            case 'rotateRight':
              _this.transform_rotate += 90;
              _this.$refs.image.handleScale(
                _this.transform_scale,
                _this.transform_rotate
              );
              break;
            case 'rotateLeft':
              _this.transform_rotate -= 90;
              _this.$refs.image.handleScale(
                _this.transform_scale,
                _this.transform_rotate
              );
              break;
            case 'zoominImage':
              _this.transform_scale += 0.1;
              _this.$refs.image.handleScale(
                _this.transform_scale,
                _this.transform_rotate
              );
              break;
            case 'zoomoutImage':
              if (_this.transform_scale > 0.1) {
                _this.transform_scale -= 0.1;
                _this.$refs.image.handleScale(
                  _this.transform_scale,
                  _this.transform_rotate
                );
              } else {
                Toast('已经调到最小');
              }
              break;
            case 'pdf':
              let { galleryid } = JSON.parse(data[0]);
              _this.$store.commit('course/setValue', {
                name: 'galleryid',
                value: galleryid
              });
              _this.handleEndScreen({ type: 'ppt' });
              _this.$router.push('/pdf');
              break;
            case 'scrollTop':
              _this.handleScrollPdf(0);
              break;
            case 'scrollBottom':
              _this.handleScrollPdf(1);
              break;
            case 'zoomoutPdf': // 缩小
              _this.handleZoomPdf(-1);
              break;
            case 'zoominPdf': // 放大
              _this.handleZoomPdf(1);
              break;
            case 'video':
              let v_file = JSON.parse(data[0]).file;
              if (v_file.indexOf('?')) {
                let fUrl = v_file.split('?');
                _this.previewFile(v_file, `${fUrl[0]}`, fUrl[0]);
              } else {
                _this.previewFile(v_file, v_file, v_file);
              }
              break;
            case 'voicePlus':
              if (!_this.projection.show) return false;
              let volume = document.getElementById('videoModel').volume;
              console.log('voicePlus', volume);
              if (volume <= 0.9) {
                volume = volume + 0.1;
                document.getElementById('videoModel').volume = volume;
                Toast((volume * 100).toFixed(0));
              } else if (volume < 1) {
                document.getElementById('videoModel').volume = 1;
              } else {
                Toast('已经调到最大音量');
              }
              break;
            case 'voiceReduce':
              if (!_this.projection.show) return false;
              let voiceReduce = document.getElementById('videoModel').volume;
              if (voiceReduce >= 0.1) {
                voiceReduce = voiceReduce - 0.1;
                document.getElementById('videoModel').volume = voiceReduce;
                Toast((voiceReduce * 100).toFixed(0));
              } else if (voiceReduce > 1) {
                document.getElementById('videoModel').volume = 0;
              } else {
                Toast('已经调到最小音量');
              }
              break;
            case 'stopVideo':
              if (!_this.projection.show) return false;
              document.getElementById('videoModel').pause();
              break;
            case 'playVideo':
              if (!_this.projection.show) return false;
              document.getElementById('videoModel').play();
              break;
            case 'jumpVideo':
              if (!_this.projection.show) return false;
              let videojumpcurrentTime = document.getElementById('videoModel')
                .currentTime;
              let videojumpduration = document.getElementById('videoModel')
                .duration;
              if (videojumpcurrentTime + 5 >= videojumpduration) {
                document.getElementById(
                  'videoModel'
                ).currentTime = videojumpduration;
                Toast('播放结束');
              } else {
                document.getElementById('videoModel').currentTime += 5;
              }
              break;
            case 'backVideo':
              if (!_this.projection.show) return false;
              let videocurrentTime = document.getElementById('videoModel')
                .currentTime;
              if (videocurrentTime - 5 <= 0) {
                document.getElementById('videoModel').currentTime = 0;
                Toast('重新播放');
              } else {
                document.getElementById('videoModel').currentTime -= 5;
              }
              break;
            case 'audio':
              let a_file = JSON.parse(data[0]).file;
              if (a_file.indexOf('?')) {
                let fUrl = a_file.split('?');
                _this.previewFile(a_file, `${fUrl[0]}`, fUrl[0]);
              } else {
                _this.previewFile(a_file, a_file, a_file);
              }
              break;
            case 'playAudio':
              if (!_this.projection.show) return false;
              document.getElementById('audioModel').play();
              break;
            case 'stopAudio':
              if (!_this.projection.show) return false;
              document.getElementById('audioModel').pause();
              break;
            case 'audioPlus':
              if (!_this.projection.show) return false;
              let audioPlus = document.getElementById('audioModel').volume;
              if (audioPlus >= 1) {
                Toast('已经调到最大音量');
              } else if (audioPlus > 0 && audioPlus < 1) {
                audioPlus = audioPlus + 0.1;
                document.getElementById('audioModel').volume = audioPlus;
              } else {
                document.getElementById('audioModel').volume = audioPlus;
                Toast('0');
              }
              break;
            case 'audioReduce':
              if (!_this.projection.show) return false;
              let audioReduce = document.getElementById('audioModel').volume;
              if (audioReduce >= 0.1) {
                audioReduce = audioReduce - 0.1;
                document.getElementById('audioModel').volume = audioReduce;
                Toast((audioReduce * 100).toFixed(0));
              } else if (audioReduce > 0) {
                audioReduce = 0;
                document.getElementById('audioModel').volume = audioReduce;
                Toast('0');
              } else {
                Toast('已经调到最小音量');
              }
              break;
            case 'jumpAudio':
              if (!_this.projection.show) return false;
              let jumpcurrentTime = document.getElementById('audioModel')
                .currentTime;
              let jumpduration = document.getElementById('audioModel').duration;
              if (jumpcurrentTime + 5 >= jumpduration) {
                document.getElementById(
                  'audioModel'
                ).currentTime = jumpduration;
                Toast('播放结束');
              } else {
                document.getElementById('audioModel').currentTime += 5;
              }
              break;
            case 'backAudio':
              if (!_this.projection.show) return false;
              let currentTime = document.getElementById('audioModel')
                .currentTime;
              if (currentTime - 5 <= 0) {
                document.getElementById('audioModel').currentTime = 0;
                Toast('重新播放');
              } else {
                document.getElementById('audioModel').currentTime -= 5;
              }
              break;
            case 'endScreen':
              _this.handleEndScreen(JSON.parse(data[0]));
              break;
            case 'updateData':
              _this.$root.$emit('updateData');
              break;
            case 'refreshReply':
              _this.$root.$emit('refreshReply');
              break;
            case 'attend':
              _this.handleEndScreen({ type: 'ppt' });
              _this.$root.$emit('attend');
              break;
            case 'noattend':
              _this.$root.$emit('noattend');
              break;
            case 'hideQr':
              _this.$root.$emit('hideQr');
              break;
            case 'showQr':
              _this.$root.$emit('showQr');
              break;
            case 'onRefresh':
              _this.$root.$emit('onRefresh', JSON.parse(data[0]));
              break;
            case 'startAttend':
              _this.$router.push('/attendance');
              break;
            case 'quiz':
              _this.handleQuiz(JSON.parse(data[0]), true);
              break;
            case 'submitStudent': // 获取已提交
              break;
            case 'unsubmitStudent': // 获取已提交
              break;
            case 'delayQuiz': // 延迟交卷
              _this.$root.$emit('delayQuiz', JSON.parse(data[0]));
              break;
            case 'submitQuiz': // 交卷
              _this.handleCloseDialog();
              _this.$router.push('/quizsituation');
              break;
            case 'quizDetail': // 作答详情
              _this.handleQuiz(JSON.parse(data[0]), false);
              break;
            case 'changePage': // 作答详情
              _this.$root.$emit('changePage', JSON.parse(data[0]));
              break;
            case 'showDialog':
              _this.handleShowDialog(JSON.parse(data[0]));
              break;
            case 'closeDialog':
              _this.handleCloseDialog();
              break;
            case 'finishTeaching':
              _this.handleCloseDialog();
              _this.$router.push('/');
              break;
            case 'randomCall':
              _this.handleEndScreen({ type: 'ppt' });
              _this.$router.push('/randomcall');
              break;
            case 'startCall':
              _this.$root.$emit('startCall', JSON.parse(data[0]));
              break;
            case 'stopCall':
              _this.handleEndScreen({ type: 'ppt' });
              _this.$root.$emit('stopCall', JSON.parse(data[0]));
              break;
            case 'randomQuestion':
              _this.handleFllowQuestion(JSON.parse(data[0]));
              _this.$router.push('/followquestion');
              break;
            // 随堂提问-学生举手
            case 'startRaiseHand':
              _this.handleRaiseHand(JSON.parse(data[0]));
              _this.$root.$emit('startRaiseHand', JSON.parse(data[0]));
              break;
            case 'forum':
              _this.handleForum(JSON.parse(data[0]));
              break;
            case 'deleteTopic':
              _this.handleCloseDialog();
              _this.$root.$emit('handleDeleteTopic', JSON.parse(data[0]));
              break;
            case 'taptopic':
              console.log('to topic');
              _this.$root.$emit('tapTopic', JSON.parse(data[0]));
              break;
            case 'startWhiteboard':
              _this.handleWhiteboard(JSON.parse(data[0]));
              break;
            case 'whiteboardRedo':
              _this.$root.$emit('whiteboardRedo', JSON.parse(data[0]));
              break;
            case 'clearAll':
              _this.$root.$emit('clearAll', JSON.parse(data[0]));
              break;
            case 'vote':
              _this.handleVote(JSON.parse(data[0]));
              break;
            case 'writing':
              _this.handleWriting(JSON.parse(data[0]));
              break;
            case 'whiteboard':
              _this.handleDrawing(data);
              break;
            case 'backLogs':
              console.log('wechat go to logs');
              if (_this.$route.name === 'homeMain') return false;
              _this.$router.replace('/home');
              break;
            case 'preview': // 预览图片
              _this.$root.$emit('previewImages', JSON.parse(data[0]));
              break;
            case 'stuOnLine': // 预览图片
              _this.handleStudentOnline(data);
              break;
            default:
              break;
          }
        };
      } catch (error) {
        console.log('err', error);
      }
    },
    async onMessage() {
      await this.$store.dispatch('websock/STAFF_WEBSOCKET');
      this.setOnMessage();
    },
    async setSiteResult() {
      let { siteurl } = this.$store.state.global;
      baseUrl.setUrl(siteurl);
      if (await this.isLogin()) {
        this.onMessage();
        this.isRouterAlive = true;
      } else {
        this.handleFinished(false);
      }
    },
    async isLogin() {
      let result = await course.getOnlineCourses({
        loadingText: '正在检查课程登录状态'
      });
      if (result) {
        let course = result.filter(
          (item) => item.id === parseInt(this.$store.state.course.courseId)
        );
        console.log('result', course.length > 0);
        return course.length > 0;
      } else {
        return false;
      }
    },
    screenfull() {
      if (!screenfull.isEnabled) {
        Toast('你的浏览器无响应');
        return false;
      }
      screenfull.toggle();
      this.$store.commit('global/SET_VALUE', {
        name: 'isFullscreen',
        value: true
      });
    }
  },
  async created() {
    console.log('1');
    if (!this.$store.getters['websock/STAFF_UPDATE'].send) {
      this.setSiteResult();
    } else {
      this.isRouterAlive = true;
      this.setOnMessage();
    }
  },
  mounted() {
    console.log('2');
    // this.$refs.canvas.initCanvas()
  }
};
</script>
<style lang="less">
.bg_container {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-size: cover;
  position: relative;
  .bg_wrapper {
    position: relative;
    // height: 92%;
    height: 100%;
    z-index: 5;
  }
  .tools {
    position: fixed;
    right: 50px;
    bottom: 50px;
    background-color: rgba(0, 0, 0, 0.19);
    width: 80px;
    height: 270px;
    border-radius: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    z-index: 3000;
  }
  .circle {
    margin-top: 5px;
    width: 70px;
    height: 70px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .title {
      font-size: 14px;
      color: #fff;
      margin-top: 5px;
    }
  }
}
.bg_container + .van-image-preview__overlay {
  z-index: 8 !important;
}
.ppt-wrapper {
  // background-color: rgba(0, 0, 0, 0.5);
  // z-index: 9 !important;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  right: 0;
  .page-tips {
    font-size: 18px;
  }
}
.custom-image-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  z-index: 2;
  img {
    max-width: 100%;
    height: auto;
    cursor: pointer;
  }
}
</style>
